import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-dark-900 border-t border-white/5" data-id="element-257">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-258">
        <div className="w-24 h-24 bg-dark-800 rounded-full flex items-center justify-center mx-auto mb-8 border-2 border-gold-500 shadow-[0_0_30px_rgba(212,175,55,0.2)]" data-id="element-259">
          <Shield className="w-12 h-12 text-gold-500" data-id="element-260" />
        </div>

        <h2 className="text-3xl font-bold text-white mb-6" data-id="element-261">
          Garantía de Satisfacción de 30 Días
        </h2>

        <p className="text-gray-300 text-lg leading-relaxed mb-6" data-id="element-262">
          Pruébalo. Úsalo. Aplícalo.
        </p>

        <p className="text-xl text-white font-medium mb-8" data-id="element-263">
          Si no sientes más control y más cierre, tienes garantía de 30 días.
        </p>

        <div className="inline-block border border-white/10 rounded-lg px-6 py-3 bg-white/5" data-id="element-264">
          <p className="text-sm text-gray-400" data-id="element-265">
            Tu inversión está protegida. Tienes cero riesgo.
          </p>
        </div>
      </div>
    </section>;
}